const Theme = {
    body_background_color: '#82C8CD',

    logo_image_url: 'inspire.png',
    logo_height: 80,

    token_url: 'inspire.png',

    number_font: `'Montserrat', sans-serif`,

    button_color: '#7DC0C5',
    button_radius: 12,

    button_half_border_color: '#7DC0C5',

    text_font: `'Montserrat', sans-serif`,

    title_font: `'Montserrat', sans-serif`,
    title_weight: 500,

    subtitle_size: 21,
  }

  export default Theme
